module.exports = __webpack_public_path__ + "img/top-bg.1d3d0c6a.png";